import axiosInstance from "../../../interceptor/intercetptor-inctence";

export const getMethodList = (formData) => {
    return axiosInstance.post(`api/master/test-method/list`, formData);
}

export const statusMethod = (id) => {
    return axiosInstance.post(`api/master/test-method/change-status?testMethodId=${id}`,{});
}

export const deleteMethod = (id) => {
    return axiosInstance.post(`api/master/test-method/delete?testMethodId=${id}`,{});
}

export const addMethod = (formData) => {
    return axiosInstance.post(`api/master/test-method/add`,formData);
}

export const updateMethod = (formData) => {
    return axiosInstance.post(`api/master/test-method/update`,formData);
}

export const getGlobalTestMethodList = () => {
    return axiosInstance.post(`api/global-master/methodologies_master`,{});
}

export const addGlobalTestMethod = (formData) => {
    return axiosInstance.post(`api/global-master/import_methodology_master`,formData);
}
